export const clickableTags = ['INPUT', 'RADIO', 'CHECKBOX', 'TEXTAREA', 'SELECT'];

export const inputsDisableToPhaseApprovalForLoss = [
  "diretoria",
  "validado_por_diretoria",
  "gerente_de_log_stica",
  "validado_por_gerente_de_log_stica",
  "gerente_de_qualidade",
  "validado_por_gerente_de_qualidade",
  "gerente_de_ccare",
  "validado_por_gerente_de_ccare"
];

export const fieldsToDisableOnQuality = [
  'tipo_do_documento',
  'n_mero_do_documento',
  'medicamentos_controlados',
  'status_do_documento',
  'data_de_vig_ncia'
];

export const labelReadOnly = [
  'Responsável pelo Atendimento',
  'Status da PD',
  'Número da PD',
  'Status da Qualidade',
  'Tipo de Recusa Qualidade',
  'Usuário Aprovador',
  'Descrição do usuário sobre a recusa'
];

export const labelMinimalReadOnly = [
  'Responsável pelo Atendimento',
  'Aprovação de Documentos'
];